var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23017 8.68435C5.52875 8.39726 6.00353 8.40657 6.29063 8.70514L12 14.6429L17.7094 8.70515C17.9965 8.40657 18.4713 8.39726 18.7698 8.68435C19.0684 8.97145 19.0777 9.44623 18.7906 9.74481L12.5406 16.2448C12.3992 16.3919 12.204 16.475 12 16.475C11.796 16.475 11.6008 16.3919 11.4594 16.2448L5.20938 9.74481C4.92228 9.44623 4.93159 8.97145 5.23017 8.68435Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic_arrow-down.f45d2ffd90adde50c9fe94b2737ac55b.svg";
export { ForwardRef as ReactComponent };